export const GET_TODO = "todos"
export const LOGIN_URL = "Login"
export const AGREEMENT_LIST = "AdobeAgreement/SearchAgreement"
export const DOCTOR_NAME_LIST = "AdobeAgreement/FetchAllDoctors"
export const DOCTOR_DATA = "AdobeAgreement/FetchDoctorById"
export const CREATE_AGREEMENT = "AdobeAgreement/CreateAgreement"
export const VIEW_AGREEMENT = "AdobeAgreement/ViewAgreement"
export const DELETE_AGREEMENT = "AdobeAgreement/DeleteAgreementById"
